"use strict";

module.exports = {
    updateArticleLinks: function () {
        var section = $(".content-breadcrumb").data("fdid");

        $(".c-blog-article-tile a").each(function () {
            var $this = $(this);
            var newRef = section ? $this.attr("href") + "?section=" + section : $this.attr("href");

            $this.attr("href", newRef);
        });
    }
};
